import { ApButtonTab } from '@alixpartners/ui-components';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ApiContext } from 'context/ApiContext';
import {
  LeftWrapper,
  RightWrapper,
  SecondaryNavigation,
} from './Settings.styles';
import {
  PERMISSIONS,
  DATA_PERMISSIONS,
  hasSomeOfRequiredPermissions,
} from 'utils/constants';
import { ISettingsResponse } from 'utils/types';

export const SettingsNavView = ({
  right,
  settings,
  permissions,
}: {
  right?: React.ReactNode;
  settings: ISettingsResponse;
  permissions: string[];
}) => {
  const location = useLocation();
  const history = useHistory();
  const isPreferencesTabAvailable = permissions.includes(
    PERMISSIONS.PREFERENCES_READ
  );
  const isDataTabAvailable = hasSomeOfRequiredPermissions(
    permissions,
    DATA_PERMISSIONS
  );
  const isClassificationTabAvailable = permissions.includes(
    PERMISSIONS.CLASSIFICATION_RULES_READ
  );
  const isBenchmarksTabAvailable = permissions.includes(
    PERMISSIONS.BENCHMARK_SETTINGS_READ
  );
  const isSettingsAvailable =
    settings &&
    settings.availableRange.startYear &&
    settings.availableRange.endYear;

  return (
    <SecondaryNavigation>
      <LeftWrapper>
        {isPreferencesTabAvailable && (
          <ApButtonTab
            isSelected={location.pathname.includes('/preferences')}
            disabled={!isSettingsAvailable}
            onClick={() => {
              history.push('/settings/preferences');
            }}
          >
            Preferences
          </ApButtonTab>
        )}
        {isDataTabAvailable && (
          <ApButtonTab
            isSelected={location.pathname.includes('/data')}
            onClick={() => {
              history.push('/settings/data');
            }}
          >
            Data
          </ApButtonTab>
        )}
        {isClassificationTabAvailable && (
          <ApButtonTab
            isSelected={location.pathname.includes('/classification')}
            onClick={() => {
              history.push('/settings/classification');
            }}
          >
            Classification Rules
          </ApButtonTab>
        )}
        {isBenchmarksTabAvailable && (
          <ApButtonTab
            isSelected={location.pathname.includes('/benchmarks')}
            onClick={() => {
              history.push('/settings/benchmarks');
            }}
          >
            Benchmarks
          </ApButtonTab>
        )}
      </LeftWrapper>

      <RightWrapper>{right}</RightWrapper>
    </SecondaryNavigation>
  );
};

export const SettingsNav = ({ right }: { right?: React.ReactNode }) => (
  <ApiContext.Consumer>
    {({ settings, permissions }) => (
      <SettingsNavView
        right={right}
        settings={settings}
        permissions={permissions}
      />
    )}
  </ApiContext.Consumer>
);
